export default __webpack_public_path__ + "static/media/Game 4 word play make the connection.c93877ba.png";